module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--de@2-9dd2f87ee93d977615f465b9b5128080.jpg";